import gql from 'graphql-tag';

import { CommentDetails } from '../fragments/comments';

export const AccountFileCommentCreate = gql`
  mutation accountFileCommentCreate($input: AccountFileCommentCreateInput!) {
    accountFileCommentCreate(input: $input) {
      account_file_comment {
        id
        ...CommentDetails
        parent {
          id
          children {
            total
          }
        }
      }
    }
  }
  ${CommentDetails}
`;

export const AccountFileCommentUpdate = gql`
  mutation accountFileCommentUpdate($input: AccountFileCommentUpdateInput!) {
    accountFileCommentUpdate(input: $input) {
      account_file_comment {
        id
        ...CommentDetails
        parent {
          id
          children {
            total
          }
        }
      }
    }
  }
  ${CommentDetails}
`;

export const AccountFileCommentDelete = gql`
  mutation accountFileCommentDelete($input: AccountFileCommentDeleteInput!) {
    accountFileCommentDelete(input: $input) {
      success
    }
  }
`;
